import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import edsiderlogo from "../../../assets/images/edsiderlogo.png";
import adminIllustration from "../../../assets/images/AdminImg.png";
import { history } from "../../../helper/history";
import { routes } from "../../../helper/routes";
import "./AdminLandingPage.css";

export default class AdminLandingPage extends Component {
  handleRoleSelect = (role) => {
    sessionStorage.setItem("user_role_selection", role);
    history.push(routes.auth_response);
  };

  render() {
    return (
      <div className="admin-landing-wrapper">
        <Container fluid className="admin-landing-container">
          <Row className="justify-content-center">
            <Col xs={12} className="text-center">
              <div className="admin-logo-section">
                <img
                  className="admin-logo-image"
                  src={edsiderlogo}
                  alt="EdSider"
                />
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col xs={12} className="text-center">
              <div className="admin-welcome-section">
                <h1 className="admin-welcome-title">Welcome!</h1>
                <p className="admin-welcome-subtitle">
                  Sign In to continue to your account
                </p>
                <div className="admin-gradient-line"></div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center admin-content-row">
            <Col xs={12} sm={10} md={8} lg={5} xl={4} className="d-flex justify-content-center">
              <div className="admin-content-card">
                <div className="admin-illustration-wrap">
                  <img
                    src={adminIllustration}
                    alt="Admin login"
                    className="admin-illustration-image"
                  />
                </div>

                <div className="admin-button-section text-center">
                  <button
                    type="button"
                    className="admin-signin-btn"
                    onClick={() => this.handleRoleSelect("admin")}
                  >
                    Sign-In
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
